var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-upload',{ref:"upload",staticClass:"upload-demo",attrs:{"action":"","on-success":_vm.readFile,"before-upload":_vm.readFile,"file-list":_vm.fileList,"auto-upload":true}},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.loadCsvFile}},[_vm._v("导入csv文件")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1eaa7b4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/loadCsvFile.vue
// module id = HJ5O
// module chunks = 2